import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./context/AuthContext";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import LoginModal from "./components/feature/LoginModal";
import ActiveTaskPrompt from "./components/feature/ActiveTaskPrompt";
import ScrollToTop from "./components/feature/ScrollToTop";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AuthProvider>
          <AdminAuthProvider>
            <AppRoutes />
            <LoginModal />
            <ActiveTaskPrompt />
          </AdminAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
